<template>
	<div class="row">
		<div class="col-12 col-md-6">

			<div class="mb-3">
				<label for="exampleFormControlInput1" class="form-label">Välj kontakt</label>
				<select class="form-select">
					<option>Tobias Rosengren</option>
				</select>
			</div>

			<div class="mb-3">
				<label for="exampleFormControlInput1" class="form-label">Namn</label>
				<input type="text" class="form-control" id="exampleFormControlInput1" placeholder="Ange namn">
			</div>

			<div class="mb-3">
				<label for="exampleFormControlInput1" class="form-label">Telefon (Frivilligt)</label>
				<input type="text" class="form-control" id="exampleFormControlInput1" placeholder="Ange ditt telefonnummer">
			</div>

			<div class="mb-3">
				<label for="exampleFormControlInput1" class="form-label">E-post</label>
				<input type="email" class="form-control" id="exampleFormControlInput1" placeholder="Ange din e-postadress">
			</div>

			<div class="mb-3">
				<label for="exampleFormControlInput1" class="form-label">Land</label>
				<select class="form-select">
					<option>Sverige</option>
				</select>
			</div>

			<div class="mb-3">
				<label class="form-label">Jag vill att säljaren kontaktar mig:</label>

				<div>
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
						<label class="form-check-label" for="inlineCheckbox1">via e-post</label>
					</div>
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
						<label class="form-check-label" for="inlineCheckbox2">via telefon</label>
					</div>
				</div>
			</div>

		</div>
		<div class="col-12 col-md-6">
			<div class="mb-3">
				<label for="inputTextArea" class="form-label">Ge säljaren ett bud eller ställ en fråga</label>
				<textarea class="form-control" id="inputTextArea" rows="15" placeholder="Jag vill veta mer om/Är intresserad av.."></textarea>
			</div>
		</div>
	</div>
</template>

<script>

export default {

	props: {
		product: {
			required: true
		},
	},

	data() {
		return {

		}
	},

	computed: {

	},

	methods: {

	}

}
</script>
